module.exports = __webpack_public_path__ + "static/media/museum_diorama_mural_concept_2002.4b346d04.webp";